import Vue from 'vue'
import Vuex from 'vuex'

/*
  acl 관리 Vuex
    - getName 함수 필수 구현
    - createInstance 함수 필수 구현
*/

const getName = () => {
  return 'acls'
}

const createInstance = () => {
  let aclstore = ''

  if (window.vue.getStore(getName) === undefined) {
    const store = new Vuex.Store({
      state: {
        aclMap: new Map() // key는 role, value는 permision 은 array 으로 구성
      },
      getters: {
        getState: state => {
          return state.aclMap
        }
      },
      mutations: {
        CLEAR (state) {
          state.aclMap.clear()
        },
        UPDATE (state, aclArray) {
          var map = state.aclMap
          let len = aclArray.length

          for (var index = 0; index < len; index++) {
            let acl = aclArray[index]
            map.set(acl.role, acl.permissions)
          }
        }
      },
      actions: {
        CLEAR ({commit}) {
          return commit('CLEAR')
        },
        UPDATE ({commit}, payload) {
          return commit('UPDATE', payload)
        }
      }
    })

    // acl vuex 용 vue instance 추가
    aclstore = new Vue({
      store: store
    })
  }

  return aclstore
}

var store = {}
store.getName = getName
store.createInstance = createInstance

export default store



// WEBPACK FOOTER //
// ./src/_fdp/core/vuex/system/acls.js